export function normaliseMe(p = {}) {
  const email = trim(p.email || p.preferred_username || p.upn || '');
  const displayName = trim(p.displayName || p.name || '');

  // Entra profile fields (DB-backed after upsert)
  const preferredName = trim(p.preferredName || p.preferred_name || '');
  const givenName = trim(p.givenName || p.given_name || '');
  const surname = trim(p.surname || '');

  const firstName =
    preferredName ||
    givenName ||
    deriveFirstName(displayName, email);

  const lastName =
    surname ||
    deriveLastName(displayName);

  const initials = deriveInitials(`${firstName} ${lastName}`.trim(), email);

  // Roles
  const globalRoleCode = trim(p.globalRoleCode || p.globalRole || p.global_role || '');
  const globalRoleName = trim(p.globalRoleName || p.globalRoleDisplay || p.global_role_name || '');

  return {
    // Auth
    isAuthenticated: !!(p.isAuthenticated ?? p.is_authenticated),

    // Identity (Scio)
    userId: p.userId ?? p.user_id ?? p.scioUserId ?? null,
    entraObjectId: p.entraObjectId ?? p.entra_object_id ?? null,

    // Primary display
    email,
    displayName,
    firstName,
    lastName,
    initials,

    // Entra profile (Graph -> DB)
    preferredName: preferredName || null,
    givenName: givenName || null,
    surname: surname || null,
    department: trim(p.department || '') || null,
    companyName: trim(p.companyName || p.company_name || '') || null,
    officeLocation: trim(p.officeLocation || p.office_location || '') || null,
    jobTitle: trim(p.jobTitle || p.job_title || '') || null,
    city: trim(p.city || '') || null,
    country: trim(p.country || '') || null,
    state: trim(p.state || '') || null,
    postalCode: trim(p.postalCode || p.postal_code || '') || null,
    streetAddress: trim(p.streetAddress || p.street_address || '') || null,

    // Account
    isEnabled: p.isEnabled ?? p.is_enabled ?? null,
    isDeleted: p.isDeleted ?? p.is_deleted ?? null,

    // Audit/activity
    createdUtc: p.createdUtc ?? p.created_utc ?? null,
    modifiedUtc: p.modifiedUtc ?? p.modified_utc ?? null,
    lastLoginUtc: p.lastLoginUtc ?? p.last_login_utc ?? null,
    lastSeenEmail: p.lastSeenEmail ?? p.last_seen_email ?? null,

    // Role
    globalRoleCode,
    globalRoleName,
  };
}

function trim(v) {
  return (v ?? '').toString().trim();
}

function deriveFirstName(displayName, email) {
  const dn = trim(displayName);
  if (dn) {
    // "Cox, Bradley" or "Bradley Cox"
    if (dn.includes(',')) {
      const parts = dn.split(',').map(s => s.trim()).filter(Boolean);
      if (parts[1]) return parts[1].split(/\s+/)[0];
      return parts[0].split(/\s+/)[0];
    }
    return dn.split(/\s+/)[0];
  }

  // last resort only
  const local = trim(email).split('@')[0] || '';
  const first = local.split(/[.\-_]/)[0] || '';
  return first ? cap(first) : '';
}

function deriveLastName(displayName) {
  const dn = trim(displayName);
  if (!dn) return '';

  if (dn.includes(',')) {
    // "Cox, Bradley" => last name "Cox"
    const parts = dn.split(',').map(s => s.trim()).filter(Boolean);
    return parts[0] || '';
  }

  const parts = dn.split(/\s+/).filter(Boolean);
  return parts.length >= 2 ? parts[parts.length - 1] : '';
}

function deriveInitials(nameOrDisplayName, email) {
  const dn = trim(nameOrDisplayName);
  if (dn) {
    const parts = dn
      .replace(',', ' ')
      .split(/\s+/)
      .filter(Boolean);
    return parts.slice(0, 2).map(p => p[0]).join('').toUpperCase();
  }

  // last resort only
  const first = deriveFirstName('', email);
  return first ? first[0].toUpperCase() : '';
}

function cap(s) {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
}